module.exports = __webpack_public_path__ + "static/img/cat.8a0023ce.gif";